<template>
  <div class="px-4">
    <form @submit.prevent="onSubmit">
      <div class="form-section">{{ $t('agent_specific.general_agent_info') }}</div>


      <b-row class="mb-3">
        <b-col md="4">
          <input-component :label="$t('general.agent_name')" :form="form" property="name" />
        </b-col>
        <b-col md="4">
          <input-component :label="$t('general.agent_id')" :form="form" property="agent_id" />
        </b-col>
        <b-col md="4">
          <select-component label="Status" :form="form" property="status" :values="vals" display="name" />
        </b-col>
      </b-row>


      <b-row class="mb-3">
        <b-col md="4">
          <input-component :label="$t('agent_specific.business_name')" :form="form" property="business_name" />
        </b-col>
        <b-col md="4">
          <input-component :label="$t('agent_specific.serial_number')" :form="form" property="serial_number" />
        </b-col>
        <b-col md="4">
          <input-component :label="$t('agent_specific.irs_ein')" :form="form" property="irs_ein" />
        </b-col>
      </b-row>


      <b-row class="mb-3">
        <b-col md="4">
          <md-datepicker
            v-bind:class="{ 'md-invalid': form.err.has('start_date') }"
            name="start_date"
            v-model="form.start_date"
            v-on:input="form.err.clear('start_date')"
          >
            <label>Start Date</label>
            <span class="md-error">{{ form.err.get("start_date") }}</span>
          </md-datepicker>
        </b-col>

        <b-col v-if="$route.params.id" md="4">
          <md-datepicker
            v-bind:class="{ 'md-invalid': form.err.has('termination_date') }"
            name="termination_date"
            v-model="form.termination_date"
            v-on:input="form.err.clear('termination_date')"
          >
            <label>Termination Date</label>
            <span class="md-error">{{ form.err.get("termination_date") }}</span>
          </md-datepicker>
        </b-col>

        <b-col v-if="$route.params.id" md="4">
          <md-field>
            <label>Termination Reasons</label>
            <md-textarea
              id="termination_reasons"
              mdAutogrow
              v-model="form.reasons_for_termination"
            ></md-textarea>
          </md-field>
        </b-col>
        
      </b-row>


      <div class="form-section mt-3">{{ $t('agent_specific.agent_location') }}</div>
      <b-row class="mb-3">
        <b-col md="4">
          <input-component label="Street" :form="form" property="street" />
        </b-col>
        <b-col md="4">
          <input-component label="City" :form="form" property="city" />
        </b-col>
        <b-col md="4">
          <select-component
            label="State"
            :form="form"
            property="state_id"
            :values="states"
            display="name"
          />
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col md="4">
          <input-component label="Zip Code" :form="form" property="zip" />
        </b-col>
        <b-col md="4">
          <div class="pt-3">
            <img
              class="mr-2"
              src="../../../assets/icons/btnUploadLocationImage.svg"
              alt
            />

            <a>
              <span @click="addImage = true" v-if="!form.store_image"
                >Choose Location Image</span
              >
              <span v-else>
                {{ form.store_image }}
                <img
                  @click="
                    (form.store_image = ''), form_data.delete('store_image')
                  "
                  src="../../../assets/icons/btnRemoveUpload.svg"
                  class="pointer ml-2"
                  alt="delete"
                />
              </span>
            </a>
          </div>
        </b-col>
      </b-row>

      <div class="form-section mt-3">Other Info</div>
      <b-row class="mb-3">
        <b-col md="4">
          <input-component
            label="Person In Charge"
            :form="form"
            property="person_in_charge"
          />
        </b-col>
        <b-col md="4">
          <input-component
            label="Phone Number"
            :form="form"
            @update="focusOut($event, 'phone_number')"
            property="phone_number"
          />
        </b-col>
        <b-col md="4">
          <input-component label="License" :form="form" property="license" />
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col md="4">
          <select-component
            :label="$t('lmt_specific.lmt_have_ownership_in_agents')"
            :form="form"
            property="ownership_in_agents"
            :values="val"
            display="name"
          />
        </b-col>
        <b-col md="4">
          <f-select
            v-on:update="addCryptoTypes($event), form.err.clear('crypto_types'), ctype++"
            field="crypto_types"
            object="id"
            :text="$t('lmt_specific.crypto_type')"
            :values="crypto_types"
            class="select-input"
            notAll="true"
            id="crypto_types"
            locale="true"
            v-if="data.agent"
            :setvalues="data.agent.crypto_types"
            v-bind:class="{ invalid: form.err.has('crypto_types') }"
          ></f-select>
          <f-select
            v-on:update="addCryptoTypes($event), form.err.clear('crypto_types'), ctype++"
            field="crypto_types"
            object="id"
            :text="$t('lmt_specific.crypto_type')"
            :values="crypto_types"
            class="select-input"
            notAll="true"
            id="crypto_types"
            locale="true"
            v-if="!$route.params.id"
            v-bind:class="{ invalid: form.err.has('crypto_types') }"
          ></f-select>
          <span
            :key="ctype"
            v-if="form.err.has('crypto_types')"
            class="invalid invalid-text"
            >{{ form.err.get("crypto_types") }}</span
          >
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col md="4">
          <input-component
            label="Expected Monthly Dollar Volume"
            :form="form"
            property="exp_mon_dollar_vol"
          />
        </b-col>
        <b-col md="4">
          <input-component
            label="Expected Monthly  number of trx"
            :form="form"
            property="exp_mon_transactions"
          />
        </b-col>
        <b-col md="4">
          <input-component
            label="Expected Monthly Avarage trx Amount"
            :form="form"
            property="exp_avg_transaction_amount"
          />
        </b-col>
      </b-row>

      <hr class="my-4" />
      <div class="form-section my-3">Documents</div>
      <b-row>
        <b-col>
          <doc-display
            id="agent_agreement"
            class="fixed-table"
            :data="form.agent_agreement"
            v-on:update="handleFile($event, 'agent_agreement', 1)"
            :text="$t('agent_specific.agent_agreement')"
            edit="true"
            type="single"
            :err="doc_errors.agent_agreement"
            v-on:remove="remove($event, 'agent_agreement', 1)"
          />
          
          <doc-display
            id="incorporation_doc"
            class="fixed-table"
            :data="form.incorporation_doc"
            v-on:update="handleFile($event, 'incorporation_doc', 1)"
            :text="$t('agent_specific.incorporation_doc')"
            edit="true"
            type="single"
            :err="doc_errors.incorporation_doc"
            v-on:remove="remove($event, 'incorporation_doc', 1)"
          />

          <doc-display
            id="compliance_handbook"
            class="fixed-table"
            :data="form.compliance_handbook"
            v-on:update="handleFile($event, 'compliance_handbook', 1)"
            :text="$t('agent_specific.compliance_handbook')"
            edit="true"
            type="single"
            :err="doc_errors.compliance_handbook"
            v-on:remove="remove($event, 'compliance_handbook', 1)"
          />

          <doc-display
            id="business_reg_formation_doc"
            class="fixed-table"
            :data="form.business_reg_formation_doc"
            v-on:update="handleFile($event, 'business_reg_formation_doc', 1)"
            text="Business Registration/Certificate of Formation"
            edit="true"
            type="single"
            :err="doc_errors.business_reg_formation_doc"
            v-on:remove="remove($event, 'business_reg_formation_doc', 1)"
          />
          
        </b-col>
      </b-row>
      <md-button
        :disabled="submitting"
        @click="preSubmit"
        class="md-primary md-raised c-primary ml-0"
      >
        <template>
          <img
            v-if="submitting"
            style="width: 30px"
            src="../../../assets/icons/load.gif"
            alt="load"
          />
          Save
        </template>
      </md-button>
    </form>

    <img-upload
      v-on:cancel="addImage = false"
      :text="form.store_image"
      v-on:update="
        form_data.append('store_image', $event),
          (form.store_image = $event.name),
          (addImage = false)
      "
      v-if="addImage"
    ></img-upload>
  </div>
</template>
<script>
import format from "date-fns/format";
import LmtSetings from "../bank/LmtSetings";//Load from crypto, this file is crypto-specific
import LmtBanks from "../../bank/LmtBanks";
import LmtImg from "../../bank/LmtImage";
import FilteredSelect from "../../form/FilteredSelect";
import OwnerIds from "../../bank/OwnerIds";

export default {
  components: {
    "owner-ids":OwnerIds,
    "lmt-setings": LmtSetings,
    "img-upload": LmtImg,
    "banks-display": LmtBanks,
    "f-select": FilteredSelect,
  },
  props: ["id"],
  data() {
    return {
      preventNextIteration: false,
      ctype: 0,
      addImage: false,
      confirm: false,
      crypto_types: [],
      form_data: new FormData(),
      dateFormat: "yyyy-MM-dd",
      states: [],
      countries: [],
      submitting: false,
      doc_errors: {},
      form_success: false,
      val: [
        { id: 0, name: "No" },
        { id: 1, name: "Yes" },
      ],
      vals: [
        { id: 0, name: "Inactive" },
        { id: 1, name: "Active" },
      ],
      doc_success: false,
      data: {},
      form: new Form({
        name: "",
        email: "",
        tax_id: "",
        agent_id: "",
        status: "",
        start_date: format(new Date(), "yyyy-MM-dd"),
        state_id: "",
        phone_number: "",
        fax: "",
        street: "",
        city: "",
        zip: "",
        termination_date: "",
        license: "",
        reasons_for_termination: "",
        person_in_charge: "",
        exp_mon_dollar_vol: "",
        exp_mon_transactions: "",
        exp_avg_transaction_amount: "",
        countries: [],
        store_image: "",
        is_agent_lmt: false,
        ownership_in_agents: "",
        agent_agreement: [],
        business_reg_formation_doc: [],
        training_doc: [],
        incorporation_doc: [],
        compliance_handbook: [],
        owner_ids: [],
        compliance_officer_designation: [],
        business_name: "",
        serial_number: "",
        irs_ein: "",
        crypto_types: []
      }),
    };
  },
  mounted() {
    let axios=window.axios;
      
    if (this.$route.params.id) {
      axios.get("/get-agent?id=" + this.$route.params.id).then(({ data }) => {
        this.data = data;
        this.form.name = data.agent.name;
        this.form.store_image = data.agent.store_image;
        this.form.email = data.user.email;
        this.form.tax_id = data.agent.tax_id;
        this.form.agent_id = data.agent.agent_id;
        this.form.state_id = data.agent.state_id;
        this.form.start_date = format(
          new Date(data.agent.start_date),
          this.dateFormat,
          new Date()
        );
        
        if (data.agent.termination_date) {
          this.form.termination_date = format(
            new Date(data.agent.termination_date),
            this.dateFormat,
            new Date()
          );
        }

        this.form.street = data.agent.street;
        this.form.city = data.agent.city;
        this.form.phone_number = data.agent.phone_number;
        this.form.zip = data.agent.zip;
        this.form.status = data.agent.status;
        this.form.ownership_in_agents = data.agent.ownership_in_agents;
        this.form.is_agent_lmt = data.agent.is_agent_lmt;
        this.form.phone_number = data.agent.phone_number;
        this.form.fax = data.agent.fax;
        this.form.license = data.agent.license;
        this.form.reasons_for_termination = data.agent.reasons_for_termination;
        this.form.training_date = format(
          new Date(data.agent.training_date),
          this.dateFormat,
          new Date()
        );
        this.form.person_in_charge = data.agent.person_in_charge;
        this.form.exp_mon_transactions = data.agent.exp_mon_transactions;
        this.form.exp_mon_dollar_vol = data.agent.exp_mon_dollar_vol;
        this.form.exp_avg_transaction_amount =
          data.agent.exp_avg_transaction_amount;
        this.form.allowed_discrepancy = data.agent.allowed_discrepancy;
        data.agent.countries.forEach(element => {
          this.form.countries.push(element.id);
        });
        data.agent.crypto_types.forEach(element => {
          this.form.crypto_types.push(element.id);
        });

        this.form.owner_ids = data.agent.owner_ids;

        this.form.business_name = data.agent.business_name;
        this.form.serial_number = data.agent.serial_number;
        this.form.irs_ein = data.agent.irs_ein;

        //append documents
        this.appendSingleToForm(data.agent, "agent_agreement");
        this.appendSingleToForm(data.agent, "incorporation_doc");
        this.appendSingleToForm(data.agent, "compliance_handbook");
        this.appendSingleToForm(data.agent, "compliance_officer_designation");
        this.appendSingleToForm(data.agent, "business_reg_formation_doc");

//        this.appendSingleToForm(data.agent, "owner_ids");
        this.appendToForm(data.agent, "owner_ids");

        this.form_data.append("training_doc", data["training_doc"]);
        this.form["training_doc"] = data.agent["training_doc"]
          ? [
              {
                doc: data.agent["training_doc"],
                id: 1,
                renewal: data.agent.training_date,
                link: data.agent.training_doc_link,
              },
            ]
          : [];
      });
    } else {
        this.form.owner_ids = [];
    }
    //load the states for filling the select box
    axios.get("/states").then(({ data }) => {
      this.states = data.states;
    });
    //load the states for filling the select box
    axios.get("/countries").then(({ data }) => {
      this.countries = data.countries;
    });

    //load the states for filling the select box
    axios.get("/crypto-types").then(({ data }) => {
      this.crypto_types = data.data;
    });
  },
  methods: {
    addCountries(data) {
      let tmp = [];
      data[0].forEach(element => {
        tmp.push(element.id);
      });
      setTimeout(() => {
        this.form.countries = tmp;
      }, 500);
    },
    addCryptoTypes(data) {
      let tmp = [];
      data[0].forEach(element => {
        tmp.push(element.id);
      });
      setTimeout(() => {
        this.form.crypto_types = tmp;
      }, 500);
    },
    appendSingleToForm(data, f) {
      this.form[f][0] = {
        doc: data[f],
      };
      this.form_data.append(f, data[f]);
    },
    appendToForm(data, f) {
      let k = f;
      if (f == "external_compliance_report" || f == "fincen_registration") {
        k = f + "s";
        data[k] = [data[f]];
      }
      for (let i = 0; i < data[k].length; i++) {
        if (data[k][i]) {
            if(k == "owner_ids") {
                this.form_data.append(k + "[doc][" + i + "]", data[k][i].doc);
                this.form_data.append(k + "[" + i + "][name]", data[k][i].name);
                this.form_data.append(k + "[" + i + "][id]", data[k][i].id);
            } else {
                this.form_data.append(k + "[doc][" + i + "]", data[k][i].doc);
                this.form_data.append(k + "[" + i + "][renewal]", data[k][i].renewal);
                this.form_data.append(k + "[" + i + "][state]", data[k][i].state_id);
            }          
        }
      }
    },
    focusOut: function (event, f) {
      if (["Arrow", "Backspace", "Shift"].includes(event.key)) {
        this.preventNextIteration = true;
        return;
      }
      if (this.preventNextIteration) {
        this.preventNextIteration = false;
        return;
      }
      let formattedPhoneValue = 0;

      formattedPhoneValue = this.form[f]
        .replace(/-/g, "")
        .match(/(\d{1,10})/g)[0];

      // Format display value based on calculated currencyValue
      this.form[f] = formattedPhoneValue.replace(
        /(\d{1,3})(\d{1,3})(\d{1,4})/g,
        "$1-$2-$3"
      );
    },
    preSubmit() {
      this.resetForm();
      let arr = [
        "compliance_officer_designation",
        "compliance_handbook",
        "incorporation_doc",
        "training_doc",
        "agent_agreement",
        "business_reg_formation_doc"
      ];
      setTimeout(() => {
        let l = 0;
        this.form["countries"].forEach((element) => {
          this.form_data.append("countries[" + l + "]", element);
          l++;
        });

        let m = 0;
        this.form["crypto_types"].forEach((element) => {
          this.form_data.append("crypto_types[" + m + "]", element);
          m++;
        });

        for (var prop in this.form) {
          if (
            Object.prototype.hasOwnProperty.call(this.form, prop) &&
            prop != "countries" &&
            prop != "crypto_types" &&
            prop != "training_doc"
          ) {
            if (!arr.includes(prop) && (!prop.startsWith("owner_ids"))) {
              this.form_data.append(prop, this.form[prop]);
            }
          }
        }
        this.submit();
      }, 1000);
    },

    //when the user try to store the provided data
    submit() {
      //set the correct url for creating or editing
      let url = "/crypto";
      
      if (this.$route.params.id) {
        url += "/lmt/agent/store/" + this.$route.params.id;
      } else {
        url += "/lmt/agent/store";
      }

      var $this = this;
      this.submitting = true;

      // if (this.form.start && !this.id)
      // this.form.start = format(this.form.start, this.dateFormat, new Date());

      /* for (var key in $this.form) {
         if (key != "annual_banking_reports")
          this.form_data.append(key, $this.form[key]);
          }
      */

      this.axios
        .post(url, this.form_data)
        .then((data) => {
          this.submitting = false;
          Event.$emit("message", [this.$t('agent_specific.agent_saved_successfully')]);
          $this.$router.push("/lmt/agents");
        })
        .catch((errors) => {
          this.submitting = false;
          this.doc_errors = errors.response.data.errors;
          this.form.err.set(errors.response.data.errors);
          this.scrollTo(Object.keys(errors.response.data.errors)[0]);
        });
    },
    scrollTo(h) {
      document.getElementById(h).scrollIntoView({ behavior: "smooth" });
    },
    resetForm() {
      let arr = [
        "compliance_officer_designation",
        "compliance_handbook",
        "incorporation_doc",
        "training_doc",
        "store_image",
        "agent_agreement",
        "business_reg_formation_doc"
      ];
      for (var key of this.form_data.keys()) {
        if (!arr.includes(key) && (!key.startsWith("owner_ids"))) {
          this.form_data.delete(key);
        }
      }
    },
    updateBanks(data) {
      this.form.bank_accounts.push(data);
    },
    handleFile(event, field, s = 0) {
      let doc = event.doc;
      let i = 0;
      let last = 0;

      this.doc_errors[field] = null;


      if (s) {
        this.form_data.delete(field);
        this.form_data.append(field, event.doc);

        let tmp_e = event;
        tmp_e.doc = tmp_e.doc.name;
        this.form[field][0] = tmp_e;
        if (field == "training_doc") {
          this.form.training_date = tmp_e.renewal;
        }

        return;
      }

      for (var key of this.form_data.keys()) {
        if (key.startsWith(field) && key.includes("doc")) i = key;
      }

      setTimeout(() => {
        if (i != 0) {
          last = parseInt(i[i.length - 2]) + 1;
        }
        let tmp_ev = event;
        tmp_ev.doc = tmp_ev.doc.name;

        if (
          field == "external_compliance_reports" ||
          field == "fincen_registrations"
        ) {
          last = 0;

          this.form[field][0] = tmp_ev;
          this.form_data.delete(field + "[doc][" + last + "]");
          this.form_data.delete(field + "[" + last + "][renewal]");
          this.form_data.delete(field + "[" + last + "][state]");
        } else {
          this.form[field].push(tmp_ev);
        }

        if(field == "owner_ids") {
            this.form_data.append(field + "[doc][" + last + "]", doc);
            this.form_data.append(field + "[" + last + "][name]", event.name);
            this.form_data.append(
              field + "[" + last + "][id]", event.id);
        } else {
            this.form_data.append(field + "[doc][" + last + "]", doc);
            this.form_data.append(field + "[" + last + "][renewal]", event.renewal);
            this.form_data.append(
              field + "[" + last + "][state]",
              event.state ? event.state.id : ""
            );
        }
        if(field != "owner_ids") {
            Event.$emit("file_uploaded", field);
        } else {
            Event.$emit("file_uploaded_owner_ids", field);
        }
//        Event.$emit("file_uploaded", field);
      }, 500);
    },

    remove(item, property, s = 0) {
      if (s) {
        this.form[property] = [];
        this.form_data.delete(property);
        this.form_data.append(property, "");
      } else {
        var filtered = this.form[property].filter(function (el) {
          return el.id != item[0].id;
        });
        this.form[property] = filtered;
        for (var key of this.form_data.keys()) {
          if (key.startsWith(property) && key.includes("[doc]")) {
            if (
              this.form_data.get(key) == item[0].doc ||
              this.form_data.get(key).name == item[0].doc
            ) {
              let last1 = item[1];

              if(property == "owner_ids") {
                    this.form_data.delete(property + "[doc][" + last1 + "]");
                    this.form_data.delete(property + "[" + last1 + "][name]");
                    this.form_data.delete(property + "[" + last1 + "][id]");
              } else {
                    this.form_data.delete(property + "[doc][" + last1 + "]");
                    this.form_data.delete(property + "[" + last1 + "][renewal]");
                    this.form_data.delete(property + "[" + last1 + "][state]");
              }
            }
          }
        }
      }
      if(property != "owner_ids") {
            Event.$emit("file_removed", property);
        } else {
            Event.$emit("file_removed_owner_ids", property);
        }
//      Event.$emit("file_removed", property);
    },
  },
};
</script>